/* Platform detection for the bits of iOS that behave differently. */
export const isIOS = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

export const isStandalone = () =>
  matchMedia('(display-mode: standalone)').matches || (navigator as Navigator & { standalone?: boolean }).standalone === true;

/* Web Push on iOS only exists inside a Home Screen web app (16.4+). In a Safari
   tab `PushManager` is simply absent, so the app must ask the user to install
   first rather than showing a permission prompt that can never appear. */
export const pushNeedsInstall = () => isIOS() && !isStandalone();

export const pushSupported = () => 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

/* WebKit renders OpenType-SVG colour fonts but not COLRv1; Chromium is the
   reverse. The tajweed mushaf ships both. */
export const isWebKit = () => /AppleWebKit/.test(navigator.userAgent) && !/Chrome|Chromium|Edg|CriOS/.test(navigator.userAgent) || isIOS();
